<template>
  <div class="CompanySelect">
    <van-field
      readonly
      clickable
      :label="label"
      :value="this.selectValue"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker[model] = true"
    />
    <van-popup
      v-model="showTermPicker[model]"
      position="bottom"
      :style="{ height: '65%' }"
    >
      <div class="popupBox">
        <div class="handleHeader">
          <div class="cardBindManagement">前十大交易对手</div>
          <div @click="showTermPicker[model] = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="handleContentNoData" v-if="corpNameList.length === 0">
          <div class="handleContentInfoNoData">暂无数据</div>
        </div>
        <div class="handleContent" v-else>
          <div
            class="handleContentList"
            @click="
              () => {
                handeIndex(index, e);
              }
            "
            :class="{ select: index === Index }"
            v-for="(e, index) in corpNameList"
            :key="index"
          >
            <div class="corpInfo">
              <div class="corpName">
                {{ e.custName }}
              </div>
              <div>
                <span class="type">{{
                  e.loanBankNo
                }}</span>
              </div>
            </div>
            <van-icon
              v-show="index === Index"
              :class="{ active: index === Index }"
              name="success"
            />
          </div>
        </div>
      </div>
    </van-popup>
    <div class="term">
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountSelect',
  props: ['label', 'placeholder', 'getSelect', 'value', 'columnsTerm'],
  data() {
    return {
      showTermPicker: {
        test: false,
      },
      model: 'test',
      Index: null,
      selectValue: '',
      corpNameList: [],
    };
  },
  watch: {
    value: {
      handler(val) {
        this.selectValue = val;
      },
      deep: true,
    },
    columnsTerm: {
      handler(val) {
        if (val) {
          console.log(val, 'cal');
          this.corpNameList = [...val];
          this.Index = this.corpNameList.findIndex((e) => e.custName === this.selectValue);
        }
      },
    },
  },
  methods: {
    handeIndex(i, value) {
      this.Index = i;
      this.getSelect(value);
      this.selectValue = value.custName;
      this.showTermPicker.test = false;
    },
  },
};
</script>
<style scoped>
.CompanySelect{
  position: relative;
}
.popupBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.handleHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
}
.handleContent {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
.handleContentInfo {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  margin-top: 40%;
}
.handleContentNoData {
  flex: 1;
  overflow: auto;
  background: #fff;
  background: url("../../../../../assets/images/nodata.png") no-repeat top center;
  background-size: contain;
}
.handleContentInfoNoData {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  margin-top: 40%;
}
.active {
  color: #ff6538;
}
.handleContentList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.select {
  background: rgba(243, 242, 242, 0.644);
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cardBindManagement {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.corpInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

}
.corpName {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #001f33;
}
.type {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
  margin-right: 4px;
}
.tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #a9b1bc;
}
.addCorp {
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #ff6538;
}
.translate {
  color: #a9b1bc;
}
.CompanySelect >>>.van-field__label{
  text-align: left;
  color: #1c2438;
}

>>> .van-field__control::-webkit-input-placeholder{
color: #828282;
}

>>> .van-field__control::-moz-input-placeholder{
color: #828282;
}

>>> .van-field__control::-ms-input-placeholder{
color: #828282;

}
</style>
